import React, { forwardRef, useImperativeHandle, useRef } from "react";
import SnMemoBox from "@shared/components/SnMemoBox";

interface popupProps {
  txtRmk: any;
}

const SN_PRD_RUN_REG_001_CHEM_POP_005 = forwardRef(
  ({ txtRmk }: popupProps, popupRef: React.Ref<any>) => {
    const memoRef = useRef<HTMLTextAreaElement>(null);

    useImperativeHandle(popupRef, () => ({
      getOkayData: () => {
        const data: any[] = [];
        data.push(memoRef.current?.value ?? txtRmk ?? "");
        return {
          rtnData: data,
        };
      },
    }));

    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          padding: "10px",
        }}
      >
        <SnMemoBox defaultValue={txtRmk} inputRef={memoRef} />
      </div>
    );
  }
);

export default SN_PRD_RUN_REG_001_CHEM_POP_005;
